export const SubscriptionStatus = {
    none: null,
    active: 'active',
    grace_period: 'grace_period',
    ended: 'ended',
    trial: 'trial',
    trial_ended: 'trial_ended',
    active_trial: 'active_trial',
};
